module.exports = __webpack_public_path__ + "static/media/nico-robin.534c45c6.png";